import AmbientOrbField from '../AmbientOrbField';
import { getGlassSurfaceRootClasses } from '../../config/glassSurfaces';

/**
 * Sign-in, sign-up and password reset live outside the app's Layout, so they drew a flat, stale background with an
 * opaque card (operator, 2026-09-23). This gives them the app's own backdrop - the dark ground and the drifting orbs -
 * and a frosted, see-through card, so logging in looks like the app you are about to use.
 */
export default function AuthShell({ children }) {
  return (
    <div
      className={`relative flex min-h-[100dvh] items-center justify-center overflow-hidden bg-gray-50 p-4 dark:bg-dark-bg ${getGlassSurfaceRootClasses()}`}
    >
      <div className="ambient-orb-layer" aria-hidden="true">
        <AmbientOrbField />
      </div>
      <div className="auth-card relative z-10 w-full max-w-sm p-8">{children}</div>
    </div>
  );
}
